import { Injectable } from '@angular/core';

import { Notification, NotificationType } from '../../types/notifications';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private _notifications: Notification[] = [];

  constructor() { }

  public get notifications(): Notification[] {
    return this._notifications;
  }

  /**
   * Create a new success Notification.
   * @param title Notification title.
   * @param message Notification message.
   * @param duration Notification ms duration.
   */
  public success(title: string, message: string, duration: number = 5000): void {
    this.notify(title, message, NotificationType.success, duration);    
  }

  /**
   * Create a new danger Notification.
   * @param title Notification title.
   * @param message Notification message.
   * @param duration Notification ms duration.
   */
  public danger(title: string, message: string, duration: number = 5000): void {
    this.notify(title, message, NotificationType.danger, duration);    
  }

  /**
   * Create a new warning Notification.
   * @param title Notification title.
   * @param message Notification message.
   * @param duration Notification ms duration.
   */
  public warning(title: string, message: string, duration: number = 5000): void {
    this.notify(title, message, NotificationType.warning, duration);    
  }

  /**
   * Create a new info Notification.
   * @param title Notification title.
   * @param message Notification message.
   * @param duration Notification ms duration.
   */
  public info(title: string, message: string, duration: number = 5000): void {
    this.notify(title, message, NotificationType.info, duration);    
  }

  /**
   * Create a new Notification and clear it when duration ends.
   * @param title Notification title.
   * @param message Notification message.
   * @param type Notification type.
   * @param duration Notification ms duration.
   */
  private notify(title: string, message: string, type: NotificationType, duration: number = 5000): void {
    const notification: Notification = {
      title,
      message,
      type: type,
      duration
    };
    this._notifications.push(notification);
    setTimeout(() => this.clearNotification(notification), duration);
  }

  /**
   * Remove a Notification from Notifications list.
   * @param notification Notification record object.
   */
  private clearNotification(notification: Notification): void {
    const index = this._notifications.indexOf(notification);
    delete this._notifications[index];
  }
}